import { Drawer } from 'ypf-pas-general-ui-components';
import PropTypes from 'prop-types';

const FilterContainer = ({ onClose, show, children }) => (
  <Drawer onClose={onClose} show={show}>
    {children}
  </Drawer>
);

export default FilterContainer;
FilterContainer.propTypes = {
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired
};
